
import React from 'react';
import {
  LayoutDashboard,
  Users,
  Calendar,
  Settings,
  Mail,
  LogOut,
  FileText,
  Bell,
  BarChart
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAdminNavigation } from '@/hooks/useAdminNavigation';
import { useAuth } from '@/contexts/auth/AuthContext';

const AdminSidebar = () => {
  const { currentSection, navigateToAdminSection, exitAdmin } = useAdminNavigation();
  const { user } = useAuth();

  // Navigation items
  const navItems = [
    {
      name: 'Vezérlőpult',
      path: 'dashboard',
      icon: <LayoutDashboard className="h-5 w-5" />
    },
    {
      name: 'Analitika',
      path: 'analytics',
      icon: <BarChart className="h-5 w-5" />
    },
    {
      name: 'Felhasználók',
      path: 'users',
      icon: <Users className="h-5 w-5" />
    },
    {
      name: 'Események',
      path: 'events',
      icon: <Calendar className="h-5 w-5" />
    },
    {
      name: 'Értesítések',
      path: 'notifications',
      icon: <Bell className="h-5 w-5" />
    },
    {
      name: 'E-mail sablonok',
      path: 'email-templates',
      icon: <Mail className="h-5 w-5" />
    },
    {
      name: 'Jelentések',
      path: 'reports',
      icon: <FileText className="h-5 w-5" />
    },
    {
      name: 'Beállítások',
      path: 'settings',
      icon: <Settings className="h-5 w-5" />
    }
  ];

  return (
    <aside className="w-64 h-screen  pt-16 bg-white border-r border-gray-200 z-10">
      <div className="flex flex-col flex-grow p-4 overflow-y-auto">
        {/* Admin user info */}
        <div className="mb-6 p-4 bg-gray-50 rounded-lg">
          <p className="text-sm font-medium">Administrator</p>
          <p className="text-sm text-gray-500">{user?.email}</p>
        </div>

        {/* Navigation items */}
        <nav className="space-y-1 flex-1">
          {navItems.map((item) => (
            <button
              key={item.path}
              onClick={() => navigateToAdminSection(item.path)}
              className={cn(
                "flex items-center px-4 py-2 text-sm font-medium rounded-md w-full text-left",
                currentSection === item.path
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              )}
            >
              {item.icon}
              <span className="ml-3">{item.name}</span>
            </button>
          ))}
        </nav>

        {/* Exit admin area */}
        <div className="pt-4 mt-6 border-t border-gray-200">
          <button
            onClick={exitAdmin}
            className="flex items-center px-4 py-2 text-sm font-medium text-red-600 rounded-md hover:bg-red-50 w-full text-left"
          >
            <LogOut className="h-5 w-5 mr-3" />
            Kilépés az admin felületről
          </button>
        </div>
      </div>
    </aside>
  );
};

export default AdminSidebar;
